<app-labels [labels]="widgetLayers.indicators[current].labels" [color]="color"></app-labels>